import logger from '@functions/logger';
// ***** Sevices *****
import { readUserAvatar } from '@services/patient';
import { postProfilePhoto } from '@services/practitioner/public-profile';
//***** Hooks *****
import { useCallback, useEffect, useState } from 'react';
// ***** Interfaces, Types and imports *****
import avatarImageWebP from '../../assets/images/blank_profile.webp';
import avatarImagePng from '../../assets/images/blank_profile.png';

type Props = {
    roleCode: 'PR' | 'PA';
    username: string;
    size: number;
    editable?: boolean;
};
const Avatar = (props: Props) => {
    const [image, setImage] = useState<undefined | string>();

    const fetchAvatar = useCallback(() => {
        readUserAvatar(props.username, props.roleCode)
            .then((blob) => {
                if (blob.size > 0) {
                    const reader = new FileReader();
                    reader.addEventListener(
                        'load',
                        () => {
                            setImage(String(reader.result));
                        },
                        false
                    );
                    reader.readAsDataURL(blob);
                }
            })
            .then((err) => {
                logger.error(err);
            });
    },[props.username, props.roleCode]);

    useEffect(() => {
        fetchAvatar();
    },[props.username, props.roleCode, fetchAvatar]);

    function updateImage() {
        if (props.editable === true) {
            const aux = document.createElement('input');
            aux.type = 'file';
            aux.style.display = 'none';
            document.body.appendChild(aux);
            aux.addEventListener('change', loadFiles);
            aux.click();
            document.body.removeChild(aux);
        }
    }
    const loadFiles = async (event: Event) => {
        const input = event.target as HTMLInputElement;
        if (!input.files?.length) {
            return;
        }
        const formData = new FormData();
        try {
            formData.append('fileImage', input.files[0]);
            if (props.username) {
                await postProfilePhoto(props.username, 'PR', formData);
            }
        } catch (error) {
            logger.error(error);
        } finally {
            fetchAvatar();
        }
    };

    return image ? (
        <picture
            onClick={updateImage}
            style={{
                height: props.size,
                width: props.size,
            }}
        >
            <source srcSet={image} type="image/png" />
            <img
                className='circle-avatar'
                width={props.size}
                height={props.size}
                src={image}
                alt="avatar"
            />
        </picture>
    ) : (
        <picture
            onClick={updateImage}
            style={{
                height: props.size,
                width: props.size,
            }}
        >
            <source srcSet={avatarImagePng} type="image/png" />
            <source srcSet={avatarImageWebP} type="image/webp" />
            <img
                className='circle-avatar'
                width={props.size}
                height={props.size}
                src={avatarImagePng}
                alt="avatar"
            />
        </picture>
    );
};

export default Avatar;
